<div class="flex flex-col gap-y-4">
	<form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="w-full flex flex-col gap-4">
		<!-- Nouveau mot de passe -->
		<div class="w-full">
			<label class="text-sm font-medium text-gray-700 mb-2 block">Nouveau mot de passe</label>
			<div class="relative">
				<input [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword"
					class="w-full h-[45px] px-3 py-2 border border-gray-300 rounded-lg placeholder:text-gray-500 text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
					placeholder="Nouveau mot de passe" />
				<button type="button" (click)="toggleNewPasswordVisibility()"
					class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
					<lucide-icon [img]="showNewPassword ? EyeOffIcon : EyeIcon" [size]="20"></lucide-icon>
				</button>
			</div>
			<div *ngIf="newPasswordError" class="text-red-500 text-xs mt-1">
				{{ newPasswordError }}
			</div>
		</div>

		<!-- Confirmation du mot de passe -->
		<div class="w-full">
			<label class="text-sm font-medium text-gray-700 mb-2 block">Confirmer le nouveau mot de passe</label>
			<div class="relative">
				<input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
					class="w-full h-[45px] px-3 py-2 border border-gray-300 rounded-lg placeholder:text-gray-500 text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
					placeholder="Confirmer le nouveau mot de passe" />
				<button type="button" (click)="toggleConfirmPasswordVisibility()"
					class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
					<lucide-icon [img]="showConfirmPassword ? EyeOffIcon : EyeIcon" [size]="20"></lucide-icon>
				</button>
			</div>
			<div *ngIf="confirmPasswordError" class="text-red-500 text-xs mt-1">
				{{ confirmPasswordError }}
			</div>
			<div *ngIf="passwordMismatchError" class="text-red-500 text-xs mt-1">
				Les mots de passe ne correspondent pas
			</div>
		</div>

		<!-- Boutons -->
		<div class="flex items-center justify-end gap-3 pt-2">
			<button type="submit" [disabled]="isLoading || passwordForm.invalid"
				class="bg-primary text-white px-6 py-2 rounded-lg text-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors hover:bg-primary/90">
				<span *ngIf="!isLoading">Changer le mot de passe</span>
				<span *ngIf="isLoading" class="flex items-center justify-center">
					<lucide-icon [img]="Loader2Icon" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" [size]="16"></lucide-icon>
					Changement en cours...
				</span>
			</button>
		</div>
	</form>

	<!-- Informations sur les critères du mot de passe -->
	<div class="mt-4 p-3 bg-blue-50 rounded-lg">
		<p class="text-xs text-blue-700 font-medium mb-2">Critères du mot de passe :</p>
		<ul class="text-xs text-blue-600 space-y-1">
			<li>• Entre 8 et 30 caractères</li>
			<li>• Au moins une lettre majuscule</li>
			<li>• Au moins une lettre minuscule</li>
			<li>• Au moins un chiffre</li>
			<li>• Au moins un caractère spécial</li>
		</ul>
	</div>
</div>